import React from 'react';
const steps = [{
  numeral: '01',
  title: 'Begin with a conversation.',
  body: 'You tell us where you are and what you’re working toward. We tell you honestly which tier fits, including whether now is the right time.'
}, {
  numeral: '02',
  title: 'Your system gets built.',
  body: 'Training and nutrition designed around your body, your schedule, and your travel, then delivered to you ready to run.'
}, {
  numeral: '03',
  title: 'You run your weeks. We watch the data.',
  body: 'Your program, your check-ins, and your progress live in one place. Your plan adjusts as your life does.'
}, {
  numeral: '04',
  title: 'The record compounds.',
  body: 'Every workout, every adjustment, every season gets kept. The longer you’re with Vera, the more precisely it fits you.'
}];
export function HowItWorks() {
  return <section id="how" className="px-6 md:px-12 lg:px-20 max-w-[88rem] mx-auto py-24 md:py-28 border-t border-ink/10" data-id="element-43" data-mp="199ujjgpg9ffq">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20" data-id="element-44" data-mp="2rkwagpcwbvio">
        <div className="md:col-span-3" data-id="element-45" data-mp="2mml10fqijn0z">
          <div className="label text-graphite/60" data-id="element-46" data-mp="2mnw6ql3ir4uq">How It Works</div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 md:gap-y-20" data-id="element-47" data-mp="31civteiy7az5">
        {steps.map(step => <div key={step.numeral} className="max-w-md" data-id="element-48" data-mp="2wj6bhglaxqc7">
            <div className="tier-numeral text-xl mb-5" data-id="element-49" data-mp="3abmg2ltupwf8">{step.numeral}</div>
            <h3 className="text-2xl md:text-[1.7rem] mb-4" data-id="element-50" data-mp="3ae07mkpboqi1">{step.title}</h3>
            <p className="font-sans font-light text-base md:text-lg text-graphite/80 leading-relaxed" data-id="element-51" data-mp="36aaqggaz9b71">
              {step.body}
            </p>
          </div>)}
      </div>
    </section>;
}